import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { reportNewClaim } from 'src/app/my-sedgwick/functions/report-newclaim';
import { scrollToElement, getUrlParams } from 'src/app/shared';
import { ExternalLinkDialogComponent } from 'src/app/shared/components/controls/dialog/external-link-dialog.component';
import { SubSink } from 'subsink';
import { DisplayService, DynamicEventBindService } from '../..';
import { ConfigurationService } from '../../services/configuration.service';
import { LearningCenterService } from '../../services/learning-center.service';
import { OpenFileService } from '../../services/openfile.service';
import { Session } from '../../services/session.service';
import { StickyMenuComponent } from '../../../shared/components/controls/sticky-menu/sticky-menu.component';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-learning-center-lv',
    template: `
    <div #dynamicContentContainer class="tw-w-full tw-flex">
      <!-- CONTENT -->
      <!-- Introduction starts -->
      @if (!loading) {
        <div class="tw-w-full">
          @if (isIntroduction) {
            <h2
              class="app-lc-header-2"
              id="lc-intro"
              role="heading"
              >
              {{ 'Introduction' | translation: translationRequest }}
            </h2>
          }
          <div class="text">
            <p [innerHTML]="learningCenter.introductionResults[0].value"></p>
          </div>
          @if (isWhatisLV) {
            <h2
              [innerHTML]="learningCenter.introductionResults[1].value"
              class="app-lc-header-2"
              id="lc-what"
              role="heading"
            ></h2>
          }
          @if (isWhatisLV) {
            <div class="app-lc-text">
              <div class="right-wrap tw-flex-none app-pl2 tw-hidden md:tw-block">
                <img
                  src="./assets/images/img_LC_introphone_desktop.webp"
                  width="69"
                  height="100"
                  alt=""
                  role="img"
                  />
                </div>
                <p [innerHTML]="learningCenter.introductionResults[2]?.value"></p>
                <p [innerHTML]="learningCenter.introductionResults[3]?.value"></p>
                <p [innerHTML]="learningCenter.introductionResults[4]?.value"></p>
                <p [innerHTML]="learningCenter.introductionResults[5]?.value"></p>
              </div>
            }
            <!-- Introduction ends -->
            <!-- FMLA Details starts -->
            @if (isFMLADetails) {
              <h2
                class="app-lc-header-2"
                id="lc-Details"
                role="heading"
                >
                {{ 'FMLA Details' | translation: translationRequest }}
              </h2>
            }
            @if (isMgr) {
              <div class="app-lc-text">
                <p>
                  @if (
                    learningCenter.fmlaDetails[1].value ||
                    learningCenter.fmlaDetails[2].value
                    ) {
                    <b
                      >{{ learningCenter.fmlaDetails[0].value }}</b
                      >
                  }
                </p>
                <p [innerHTML]="learningCenter.fmlaDetails[1].value"></p>
                <p [innerHTML]="learningCenter.fmlaDetails[2].value"></p>
              </div>
              <br />
              <div class="app-lc-text">
                <p>
                  @if (
                    learningCenter.fmlaDetails[4].value ||
                    learningCenter.fmlaDetails[5].value
                    ) {
                    <b
                      >{{ learningCenter.fmlaDetails[3].value }}</b
                      >
                    }
                  </p>
                  <p [innerHTML]="learningCenter.fmlaDetails[4].value"></p>
                  <p [innerHTML]="learningCenter.fmlaDetails[5].value"></p>
                </div>
                <br />
                <div class="app-lc-text">
                  <p>
                    @if (
                      learningCenter.fmlaDetails[7].value ||
                      learningCenter.fmlaDetails[8].value
                      ) {
                      <b
                        >{{ learningCenter.fmlaDetails[6].value }}</b
                        >
                      }
                    </p>
                    <p [innerHTML]="learningCenter.fmlaDetails[7].value"></p>
                    <p [innerHTML]="learningCenter.fmlaDetails[8].value"></p>
                  </div>
                  <br />
                  <div class="app-lc-text">
                    <p>
                      @if (
                        learningCenter.fmlaDetails[10].value ||
                        learningCenter.fmlaDetails[11].value
                        ) {
                        <b
                          >{{ learningCenter.fmlaDetails[9].value }}</b
                          >
                        }
                      </p>
                      <p [innerHTML]="learningCenter.fmlaDetails[10].value"></p>
                      <p [innerHTML]="learningCenter.fmlaDetails[11].value"></p>
                    </div>
                    <br />
                    <div class="app-lc-text">
                      <p>
                        @if (
                          learningCenter.fmlaDetails[13].value ||
                          learningCenter.fmlaDetails[14].value ||
                          learningCenter.fmlaDetails[15].value ||
                          learningCenter.fmlaDetails[16].value
                          ) {
                          <b
                            >{{ learningCenter.fmlaDetails[12].value }}</b
                            >
                          }
                        </p>
                        <p [innerHTML]="learningCenter.fmlaDetails[13].value"></p>
                        <p [innerHTML]="learningCenter.fmlaDetails[14].value"></p>
                        <p [innerHTML]="learningCenter.fmlaDetails[15].value"></p>
                        <p [innerHTML]="learningCenter.fmlaDetails[16].value"></p>
                      </div>
                    } @else {
                      <div class="app-lc-text">
                        <p>
                          @if (
                            learningCenter.fmlaDetails[1].value ||
                            learningCenter.fmlaDetails[2].value
                            ) {
                            <b
                              >{{ learningCenter.fmlaDetails[0].value }}</b
                              >
                            }
                          </p>
                          <p [innerHTML]="learningCenter.fmlaDetails[1].value"></p>
                          <p [innerHTML]="learningCenter.fmlaDetails[2].value"></p>
                        </div>
                        <br />
                        <div class="app-lc-text">
                          <p>
                            @if (
                              learningCenter.fmlaDetails[4].value ||
                              learningCenter.fmlaDetails[5].value
                              ) {
                              <b
                                >{{ learningCenter.fmlaDetails[3].value }}</b
                                >
                              }
                            </p>
                            <p [innerHTML]="learningCenter.fmlaDetails[4].value"></p>
                            <p [innerHTML]="learningCenter.fmlaDetails[5].value"></p>
                          </div>
                          <br />
                          <div class="app-lc-text">
                            <p>
                              @if (
                                learningCenter.fmlaDetails[7].value ||
                                learningCenter.fmlaDetails[8].value
                                ) {
                                <b
                                  >{{ learningCenter.fmlaDetails[6].value }}</b
                                  >
                                }
                              </p>
                              <p [innerHTML]="learningCenter.fmlaDetails[7].value"></p>
                              <p [innerHTML]="learningCenter.fmlaDetails[8].value"></p>
                            </div>
                            <br />
                            <div class="app-lc-text">
                              <p>
                                @if (
                                  learningCenter.fmlaDetails[10].value ||
                                  learningCenter.fmlaDetails[11].value
                                  ) {
                                  <b
                                    >{{ learningCenter.fmlaDetails[9].value }}</b
                                    >
                                  }
                                </p>
                                <p [innerHTML]="learningCenter.fmlaDetails[10].value"></p>
                                <p [innerHTML]="learningCenter.fmlaDetails[11].value"></p>
                              </div>
                              <br />
                              <div class="app-lc-text">
                                <p>
                                  @if (
                                    learningCenter.fmlaDetails[13].value ||
                                    learningCenter.fmlaDetails[14].value ||
                                    learningCenter.fmlaDetails[15].value ||
                                    learningCenter.fmlaDetails[16].value
                                    ) {
                                    <b
                                      >{{ learningCenter.fmlaDetails[12].value }}</b
                                      >
                                    }
                                  </p>
                                  <p [innerHTML]="learningCenter.fmlaDetails[13].value"></p>
                                  <p [innerHTML]="learningCenter.fmlaDetails[14].value"></p>
                                  <p [innerHTML]="learningCenter.fmlaDetails[15].value"></p>
                                  <p [innerHTML]="learningCenter.fmlaDetails[16].value"></p>
                                </div>
                              }
                              <!-- FMLA Details ends -->
                              <!-- Submitting Claim Information -->
                              <h2 class="app-lc-header-2" id="lc-sub" role="heading">
                                {{ 'FMLA Submitting Claim Information' | translation: translationRequest }}
                              </h2>
                              @if (isMgr) {
                                <div>
                                  <app-learning-center-section
                                    label="{{ learningCenter.submittingclaiminformations[0].value }}"
                                    icon="1"
                                    layout="bullet"
                                    >
                                    <p
                [innerHTML]="
                  learningCenter.submittingclaiminformations[1].value
                "
                                    ></p>
                                    <p>
                                      <b>{{ learningCenter.submittingclaiminformations[2].value }}</b>
                                    </p>
                                    <div class="app-p">
                                      <ul class="tw-list-disc tw-list-inside">
                                        @if (learningCenter.submittingclaiminformations[3]?.value) {
                                          <li
                    [innerHtml]="
                      learningCenter.submittingclaiminformations[3].value
                    "
                                            >
                                            {{ learningCenter.submittingclaiminformations[3].value }}
                                          </li>
                                        }
                                        @if (learningCenter.submittingclaiminformations[4]?.value) {
                                          <li
                                            >
                                            {{ learningCenter.submittingclaiminformations[4].value }}
                                          </li>
                                        }
                                        @if (learningCenter.submittingclaiminformations[5]?.value) {
                                          <li
                                            >
                                            {{ learningCenter.submittingclaiminformations[5].value }}
                                          </li>
                                        }
                                        @if (learningCenter.submittingclaiminformations[6]?.value) {
                                          <li
                                            >
                                            {{ learningCenter.submittingclaiminformations[6].value }}
                                          </li>
                                        }
                                        @if (learningCenter.submittingclaiminformations[7]?.value) {
                                          <li
                                            >
                                            {{ learningCenter.submittingclaiminformations[7].value }}
                                          </li>
                                        }
                                      </ul>
                                    </div>
                                    @if (
                                      learningCenter.submittingclaiminformations[8]?.value
                                    ) {
                                      <p
                                        [innerHTML]="
                                          learningCenter.submittingclaiminformations[8].value
                                        "
                                      ></p>
                                    }
                                  </app-learning-center-section>
                                  <app-learning-center-section
                                    label="{{ learningCenter.submittingclaiminformations[9].value }}"
                                    icon="2"
                                    layout="bullet"
                                    >
                                    <p
                [innerHTML]="
                  learningCenter.submittingclaiminformations[10].value
                "
                                    ></p>
                                    @if (isShown) {
                                      <p
                [innerHTML]="
                  learningCenter.submittingclaiminformations[11].value
                "
                                      ></p>
                                    }
                                  </app-learning-center-section>
                                  <app-learning-center-section
                                    label="{{ learningCenter.submittingclaiminformations[12].value }}"
                                    icon="3"
                                    layout="bullet"
                                    >
                                    <p
                [innerHTML]="
                  learningCenter.submittingclaiminformations[13].value
                "
                                    ></p>
                                    @if (isShown) {
                                      <p
                [innerHTML]="
                  learningCenter.submittingclaiminformations[14].value
                "
                                      ></p>
                                    }
                                    <p>
                                      <b>
                                        {{ learningCenter.submittingclaiminformations[15].value }}</b
                                        >
                                      </p>
                                      <p>
                                        <b>
                                          {{ learningCenter.submittingclaiminformations[16].value }}</b
                                          >
                                        </p>
                                        <p
                [innerHTML]="
                  learningCenter.submittingclaiminformations[17].value
                "
                                        ></p>
                                        <p>
                                          <b>
                                            {{ learningCenter.submittingclaiminformations[18].value }}</b
                                            >
                                          </p>
                                          <p
                [innerHTML]="
                  learningCenter.submittingclaiminformations[19].value
                "
                                          ></p>
                                        </app-learning-center-section>
                                        @if (
                                          this.learningCenter.submittingclaiminformations[20].value ||
                                          this.learningCenter.submittingclaiminformations[21].value ||
                                          this.learningCenter.submittingclaiminformations[22].value ||
                                          this.learningCenter.submittingclaiminformations[23].value ||
                                          this.learningCenter.submittingclaiminformations[24].value
                                          ) {
                                          <app-learning-center-section
                                            label="{{ learningCenter.submittingclaiminformations[20].value }}"
                                            icon="4"
                                            layout="bullet"
                                            >
                                            <div
                                              class="tw-w-full tw-flex tw-flex-col md:tw-flex-row tw-flex-wrap tw-justify-items-stretch"
                                              >
                                              @if (
                                                this.claimConfigService.getFeatureAccess(
                                                'UploadDocuments'
                                                ) &&
                                                isMgr &&
                                                isShown
                                                ) {
                                                <app-learning-center-section
                                                  class="tw-basis-1/4 app-color-teal"
                                                  layout="icon-small"
                                                  icon="upload_file"
                                                  >
                                                  <a
                                                    tabindex="0"
                                                    label="Documents"
                                                    class="go-to-documents-upload"
                                                    (click)="redirectToDocUpload()"
                                                    >{{ 'Upload documents' | translation: translationRequest }}</a
                                                    >
                                                  </app-learning-center-section>
                                                }
                                                @if (learningCenter.submittingclaiminformations[22]?.value) {
                                                  <app-learning-center-section
                                                    class="tw-basis-1/4"
                                                    layout="icon-small"
                                                    icon="mail"
                                                    >
                                                    {{ 'Mail' | translation: translationRequest }}:<br />
                                                    <span
                    [innerHTML]="
                      learningCenter.submittingclaiminformations[22]?.value
                    "
                                                    ></span>
                                                  </app-learning-center-section>
                                                }
                                                @if (learningCenter.submittingclaiminformations[23]?.value) {
                                                  <app-learning-center-section
                                                    class="tw-basis-1/4"
                                                    layout="icon-small"
                                                    icon="fax"
                                                    >
                                                    {{ 'Fax' | translation: translationRequest }}:<br />
                                                    <span
                    [innerHTML]="
                      learningCenter.submittingclaiminformations[23]?.value
                    "
                                                    ></span>
                                                  </app-learning-center-section>
                                                }
                                                @if (learningCenter.submittingclaiminformations[24]?.value) {
                                                  <app-learning-center-section
                                                    class="tw-basis-1/4"
                                                    layout="icon-small"
                                                    icon="laptop_mac"
                                                    >
                                                    {{ 'Email' | translation: translationRequest }}:<br />
                                                    <span
                    [innerHTML]="
                      learningCenter.submittingclaiminformations[24]?.value
                    "
                                                    ></span>
                                                  </app-learning-center-section>
                                                }
                                              </div>
                                            </app-learning-center-section>
                                          }
                                        </div>
                                      } @else {
                                        <div>
                                          <app-learning-center-section
                                            label="{{ learningCenter.submittingclaiminformations[0].value }}"
                                            icon="1"
                                            layout="bullet"
                                            >
                                            <p
                [innerHTML]="
                  learningCenter.submittingclaiminformations[1].value
                "
                                            ></p>
                                            <p>
                                              <b>{{ learningCenter.submittingclaiminformations[2].value }}</b>
                                            </p>
                                            <div class="app-p">
                                              <ul class="tw-list-disc tw-list-inside">
                                                @if (learningCenter.submittingclaiminformations[3]?.value) {
                                                  <li
                                                    >
                                                    {{ learningCenter.submittingclaiminformations[3].value }}
                                                  </li>
                                                }
                                                @if (learningCenter.submittingclaiminformations[4]?.value) {
                                                  <li
                                                    >
                                                    {{ learningCenter.submittingclaiminformations[4].value }}
                                                  </li>
                                                }
                                                @if (learningCenter.submittingclaiminformations[5]?.value) {
                                                  <li
                                                    >
                                                    {{ learningCenter.submittingclaiminformations[5].value }}
                                                  </li>
                                                }
                                                @if (learningCenter.submittingclaiminformations[6]?.value) {
                                                  <li
                                                    >
                                                    {{ learningCenter.submittingclaiminformations[6].value }}
                                                  </li>
                                                }
                                                @if (learningCenter.submittingclaiminformations[7]?.value) {
                                                  <li
                                                    >
                                                    {{ learningCenter.submittingclaiminformations[7].value }}
                                                  </li>
                                                }
                                              </ul>
                                            </div>
                                            @if (
                                              learningCenter.submittingclaiminformations[8]?.value
                                             ) {
                                              <p
                                                [innerHTML]="
                                                  learningCenter.submittingclaiminformations[8].value
                                                "
                                              ></p>
                                            }
                                          </app-learning-center-section>
                                          <app-learning-center-section
                                            label="{{ learningCenter.submittingclaiminformations[9].value }}"
                                            icon="2"
                                            layout="bullet"
                                            >
                                            <p
                [innerHTML]="
                  learningCenter.submittingclaiminformations[10].value
                "
                                            ></p>
                                            @if (isShown) {
                                              <p
                [innerHTML]="
                  learningCenter.submittingclaiminformations[11]?.value
                "
                                              ></p>
                                            }
                                          </app-learning-center-section>
                                          <app-learning-center-section
                                            label="{{ learningCenter.submittingclaiminformations[12].value }}"
                                            icon="3"
                                            layout="bullet"
                                            >
                                            <p
                [innerHTML]="
                  learningCenter.submittingclaiminformations[13].value
                "
                                            ></p>
                                            @if (isShown) {
                                              <p
                [innerHTML]="
                  learningCenter.submittingclaiminformations[14].value
                "
                                              ></p>
                                            }
                                            <p>
                                              <b>
                                                {{ learningCenter.submittingclaiminformations[15].value }}</b
                                                >
                                              </p>
                                              <p>
                                                <b>
                                                  {{ learningCenter.submittingclaiminformations[16].value }}</b
                                                  >
                                                </p>
                                                <p
                [innerHTML]="
                  learningCenter.submittingclaiminformations[17].value
                "
                                                ></p>
                                                <p>
                                                  <b>
                                                    {{ learningCenter.submittingclaiminformations[18].value }}</b
                                                    >
                                                  </p>
                                                  <p
                [innerHTML]="
                  learningCenter.submittingclaiminformations[19].value
                "
                                                  ></p>
                                                </app-learning-center-section>
                                                @if (
                                                  this.learningCenter.submittingclaiminformations[20].value ||
                                                  this.learningCenter.submittingclaiminformations[21].value ||
                                                  this.learningCenter.submittingclaiminformations[22].value ||
                                                  this.learningCenter.submittingclaiminformations[23].value ||
                                                  this.learningCenter.submittingclaiminformations[24].value
                                                  ) {
                                                  <app-learning-center-section
                                                    label="{{ learningCenter.submittingclaiminformations[20].value }}"
                                                    icon="4"
                                                    layout="bullet"
                                                    >
                                                    <div
                                                      class="tw-w-full tw-flex tw-flex-col md:tw-flex-row tw-flex-wrap tw-justify-items-stretch"
                                                      >
                                                      @if (
                                                        this.claimConfigService.getFeatureAccess(
                                                        'UploadDocuments'
                                                        ) &&
                                                        !isMgr &&
                                                        isShown
                                                        ) {
                                                        <app-learning-center-section
                                                          class="tw-basis-1/4 app-color-teal"
                                                          layout="icon-small"
                                                          icon="upload_file"
                                                          >
                                                          <a
                                                            tabindex="0"
                                                            label="Documents"
                                                            class="go-to-documents-upload"
                                                            (click)="redirectToDocUpload()"
                                                            >{{ 'Upload documents' | translation: translationRequest }}</a
                                                            >
                                                          </app-learning-center-section>
                                                        }
                                                        @if (learningCenter.submittingclaiminformations[22]?.value) {
                                                          <app-learning-center-section
                                                            class="tw-basis-1/4"
                                                            layout="icon-small"
                                                            icon="mail"
                                                            >
                                                            {{ 'Mail' | translation: translationRequest }}:<br />
                                                            <span
                    [innerHTML]="
                      learningCenter.submittingclaiminformations[22]?.value
                    "
                                                            ></span>
                                                          </app-learning-center-section>
                                                        }
                                                        @if (learningCenter.submittingclaiminformations[23]?.value) {
                                                          <app-learning-center-section
                                                            class="tw-basis-1/4"
                                                            layout="icon-small"
                                                            icon="fax"
                                                            >
                                                            {{ 'Fax' | translation: translationRequest }}:<br />
                                                            <span
                    [innerHTML]="
                      learningCenter.submittingclaiminformations[23]?.value
                    "
                                                            ></span>
                                                          </app-learning-center-section>
                                                        }
                                                        @if (learningCenter.submittingclaiminformations[24]?.value) {
                                                          <app-learning-center-section
                                                            class="tw-basis-1/4"
                                                            layout="icon-small"
                                                            icon="laptop_mac"
                                                            >
                                                            {{ 'Email' | translation: translationRequest }}:<br />
                                                            <span
                    [innerHTML]="
                      learningCenter.submittingclaiminformations[24]?.value
                    "
                                                            ></span>
                                                          </app-learning-center-section>
                                                        }
                                                      </div>
                                                    </app-learning-center-section>
                                                  }
                                                </div>
                                              }
                                              <!-- Submitting Claim Information ends -->
                                              <!--FMLA what next -->
                                              @if (isWhatsnext) {
                                                <h2
                                                  class="app-lc-header-2"
                                                  id="lc-next"
                                                  role="heading"
                                                  >
                                                  {{ "What's Next" | translation: translationRequest }}
                                                </h2>
                                              }
                                              @if (isMgr) {
                                                <div class="app-lc-text">
                                                  @if (isWhatsnext) {
                                                    <div
                                                      class="right-wrap app-pl2 tw-hidden md:tw-block"
                                                      >
                                                      <img
                                                        src="./assets/images/img_LC_WhatsNext_computer.webp"
                                                        width="141"
                                                        height="100"
                                                        alt=""
                                                        role="img"
                                                        />
                                                      </div>
                                                    }
                                                    <p [innerHTML]="learningCenter.whatsnexts[0].value"></p>
                                                    @if (
                                                      lcType === 'CONTROLLER' || lcType === 'MANAGER') {
                                                      @if (
                                                        (isShown &&
                                                        learningCenter.whatsnexts[2]?.value &&
                                                        learningCenter.whatsnexts[3]?.value) ||
                                                        (this.claimConfigService.getConfigFeatureAccess(
                                                        'notificationpreferences'
                                                        ) &&
                                                        learningCenter.whatsnexts[5]?.value &&
                                                        learningCenter.whatsnexts[6]?.value) ||
                                                        (learningCenter.whatsnexts[7]?.value &&
                                                        learningCenter.whatsnexts[8]?.value &&
                                                        learningCenter.whatsnexts[9]?.value)
                                                        ) {
                                                        <p
                                                          [innerHTML]="learningCenter.whatsnexts[1]?.value"
                                                        ></p>
                                                      }
                                                      <div>
                                                        @if (isShown && learningCenter.whatsnexts[3]?.value) {
                                                          <app-learning-center-section
                                                            label="{{ learningCenter.whatsnexts[2]?.value }}"
                                                            icon="laptop_mac"
                                                            layout="icon"
                                                            >
                                                            <p [innerHTML]="learningCenter.whatsnexts[3]?.value"></p>
                                                          </app-learning-center-section>
                                                        }
                                                      </div>
                                                      @if (learningCenter.whatsnexts[5]?.value) {
                                                        <app-learning-center-section
                                                          layout="icon"
                                                          icon="chat"
                                                          label="{{ learningCenter.whatsnexts[4].value }}"
                                                          >
                                                          <p [innerHTML]="learningCenter.whatsnexts[5].value"></p>
                                                        </app-learning-center-section>
                                                      }
                                                    } @else {
                                                      @if (
                                                        (isShown && learningCenter.whatsnexts[3]?.value) ||
                                                        (learningCenter.whatsnexts[4]?.value &&
                                                        learningCenter.whatsnexts[5]?.value) ||
                                                        (learningCenter.whatsnexts[7]?.value &&
                                                        learningCenter.whatsnexts[8]?.value &&
                                                        learningCenter.whatsnexts[9]?.value &&
                                                        learningCenter.whatsnexts[9]?.value) ||
                                                        (this.claimConfigService.getConfigFeatureAccess(
                                                        'notificationpreferences'
                                                        ) &&
                                                        learningCenter.whatsnexts[5]?.value &&
                                                        learningCenter.whatsnexts[6]?.value)
                                                        ) {
                                                        <p
                                                          [innerHTML]="learningCenter.whatsnexts[1]?.value"
                                                        ></p>
                                                      }
                                                      <div>
                                                        @if (isShown && learningCenter.whatsnexts[3]?.value) {
                                                          <app-learning-center-section
                                                            label="{{ learningCenter.whatsnexts[2]?.value }}"
                                                            icon="laptop_mac"
                                                            layout="icon"
                                                            >
                                                            <p [innerHTML]="learningCenter.whatsnexts[3]?.value"></p>
                                                          </app-learning-center-section>
                                                        }
                                                      </div>
                                                      @if (
                                                        learningCenter.whatsnexts[5]?.value &&
                                                        this.claimConfigService.getConfigFeatureAccess(
                                                        'notificationpreferences'
                                                        )
                                                        ) {
                                                        <app-learning-center-section
                                                          layout="icon"
                                                          icon="chat"
                                                          label="{{ learningCenter.whatsnexts[4].value }}"
                                                          >
                                                          <p [innerHTML]="learningCenter.whatsnexts[5].value"></p>
                                                        </app-learning-center-section>
                                                      }
                                                    }
                                                    <div>
                                                      @if (learningCenter.whatsnexts[8]?.value) {
                                                        <app-learning-center-section
                                                          label="{{ learningCenter.whatsnexts[6]?.value }}"
                                                          icon="contact_phone"
                                                          layout="icon"
                                                          >
                                                          <p
                  [innerHTML]="
                    learningCenter.whatsnexts[7]?.value +
                    ' ' +
                    learningCenter.whatsnexts[8]?.value +
                    ' ' +
                    learningCenter.whatsnexts[9]?.value
                  "
                                                          ></p>
                                                        </app-learning-center-section>
                                                      }
                                                    </div>
                                                  </div>
                                                } @else {
                                                  <div class="app-lc-text">
                                                    @if (isWhatsnext) {
                                                      <div
                                                        class="right-wrap app-pl2 tw-hidden md:tw-block"
                                                        >
                                                        <img
                                                          src="./assets/images/img_LC_WhatsNext_computer.webp"
                                                          width="141"
                                                          height="100"
                                                          alt=""
                                                          role="img"
                                                          />
                                                        </div>
                                                      }
                                                      <p [innerHTML]="learningCenter.whatsnexts[0].value"></p>
                                                      @if (
                                                        (isShown && learningCenter.whatsnexts[3]?.value) ||
                                                        (learningCenter.whatsnexts[4]?.value &&
                                                        learningCenter.whatsnexts[5]?.value) ||
                                                        (learningCenter.whatsnexts[7]?.value &&
                                                        learningCenter.whatsnexts[8]?.value &&
                                                        learningCenter.whatsnexts[9]?.value &&
                                                        learningCenter.whatsnexts[9]?.value) ||
                                                        (this.claimConfigService.getConfigFeatureAccess(
                                                        'notificationpreferences'
                                                        ) &&
                                                        learningCenter.whatsnexts[5]?.value &&
                                                        learningCenter.whatsnexts[6]?.value)
                                                        ) {
                                                        <p
                                                          [innerHTML]="learningCenter.whatsnexts[1]?.value"
                                                        ></p>
                                                      }
                                                      <div>
                                                        @if (isShown && learningCenter.whatsnexts[3]?.value) {
                                                          <app-learning-center-section
                                                            label="{{ learningCenter.whatsnexts[2]?.value }}"
                                                            icon="laptop_mac"
                                                            layout="icon"
                                                            >
                                                            <p [innerHTML]="learningCenter.whatsnexts[3]?.value"></p>
                                                          </app-learning-center-section>
                                                        }
                                                      </div>
                                                      @if (
                                                        this.claimConfigService.getConfigFeatureAccess(
                                                        'notificationpreferences'
                                                        ) && learningCenter.whatsnexts[5]?.value
                                                        ) {
                                                        <app-learning-center-section
                                                          layout="icon"
                                                          icon="chat"
                                                          label="{{ learningCenter.whatsnexts[4].value }}"
                                                          >
                                                          <p [innerHTML]="learningCenter.whatsnexts[5]?.value"></p>
                                                        </app-learning-center-section>
                                                      }
                                                      <div>
                                                        @if (learningCenter.whatsnexts[8]?.value) {
                                                          <app-learning-center-section
                                                            label="{{ learningCenter.whatsnexts[6]?.value }}"
                                                            icon="contact_phone"
                                                            layout="icon"
                                                            >
                                                            <p
                  [innerHTML]="
                    learningCenter.whatsnexts[7]?.value +
                    ' ' +
                    learningCenter.whatsnexts[8]?.value +
                    ' ' +
                    learningCenter.whatsnexts[9]?.value
                  "
                                                            ></p>
                                                          </app-learning-center-section>
                                                        }
                                                      </div>
                                                    </div>
                                                  }
                                                  <!-- FMLA what next ends -->
                                                  <!-- FMLA After Decision starts-->
                                                  @if (isAfterdecision) {
                                                    <h2
                                                      class="app-lc-header-2"
                                                      id="lc-after"
                                                      role="heading"
                                                      >
                                                      {{ 'FMLA After Your Decision is Made' | translation: translationRequest }}
                                                    </h2>
                                                  }
                                                  @if (isMgr) {
                                                    <div class="app-lc-text">
                                                      <p>
                                                        @if (learningCenter.afterDecide[1].value) {
                                                          <b
                                                            [innerHTML]="learningCenter.afterDecide[0].value"
                                                            ></b
                                                            >
                                                          }<br />
                                                          <span [innerHTML]="learningCenter.afterDecide[1].value"></span>
                                                        </p>
                                                        <p>
                                                          @if (learningCenter.afterDecide[3].value) {
                                                            <b
                                                              [innerHTML]="learningCenter.afterDecide[2].value"
                                                              ></b
                                                              >
                                                              }<br />
                                                              <span [innerHTML]="learningCenter.afterDecide[3].value"></span>
                                                            </p>
                                                            <p>
                                                              @if (learningCenter.afterDecide[5].value) {
                                                                <b
                                                                  [innerHTML]="learningCenter.afterDecide[4].value"
                                                                  ></b
                                                                  >
                                                                  }<br />
                                                                  <span [innerHTML]="learningCenter.afterDecide[5].value"></span>
                                                                </p>
                                                                <p>
                                                                  @if (learningCenter.afterDecide[7].value) {
                                                                    <b
                                                                      [innerHTML]="learningCenter.afterDecide[6].value"
                                                                      ></b
                                                                      >
                                                                      }<br />
                                                                      <span [innerHTML]="learningCenter.afterDecide[7].value"></span>
                                                                    </p>
                                                                    <p>
                                                                      @if (learningCenter.afterDecide[9].value) {
                                                                        <b
                                                                          [innerHTML]="learningCenter.afterDecide[8].value"
                                                                          ></b
                                                                          >
                                                                          }<br />
                                                                          <span [innerHTML]="learningCenter.afterDecide[9].value"></span>
                                                                        </p>
                                                                        <p>
                                                                          @if (learningCenter.afterDecide[11]?.value) {
                                                                            <b
                                                                              [innerHTML]="learningCenter.afterDecide[10]?.value"
                                                                              ></b
                                                                              >
                                                                              }<br />
                                                                              <span [innerHTML]="learningCenter.afterDecide[11]?.value"></span>
                                                                            </p>
                                                                          </div>
                                                                        } @else {
                                                                          <div class="app-lc-text">
                                                                            <p>
                                                                              @if (learningCenter.afterDecide[1].value) {
                                                                                <b
                                                                                  [innerHTML]="learningCenter.afterDecide[0].value"
                                                                                  ></b
                                                                                  >
                                                                                  }<br />
                                                                                  <span [innerHTML]="learningCenter.afterDecide[1].value"></span>
                                                                                </p>
                                                                                <p>
                                                                                  @if (learningCenter.afterDecide[3].value) {
                                                                                    <b
                                                                                      [innerHTML]="learningCenter.afterDecide[2].value"
                                                                                      ></b
                                                                                      >
                                                                                      }<br />
                                                                                      <span [innerHTML]="learningCenter.afterDecide[3].value"></span>
                                                                                    </p>
                                                                                    <p>
                                                                                      @if (learningCenter.afterDecide[5].value) {
                                                                                        <b
                                                                                          [innerHTML]="learningCenter.afterDecide[4].value"
                                                                                          ></b
                                                                                          >
                                                                                          }<br />
                                                                                          <span [innerHTML]="learningCenter.afterDecide[5].value"></span>
                                                                                        </p>
                                                                                        <p>
                                                                                          @if (learningCenter.afterDecide[7].value) {
                                                                                            <b
                                                                                              [innerHTML]="learningCenter.afterDecide[6].value"
                                                                                              ></b
                                                                                              >
                                                                                              }<br />
                                                                                              <span [innerHTML]="learningCenter.afterDecide[7].value"></span>
                                                                                            </p>
                                                                                            <p>
                                                                                              @if (learningCenter.afterDecide[9].value) {
                                                                                                <b
                                                                                                  [innerHTML]="learningCenter.afterDecide[8].value"
                                                                                                  ></b
                                                                                                  >
                                                                                                  }<br />
                                                                                                  <span [innerHTML]="learningCenter.afterDecide[9].value"></span>
                                                                                                </p>
                                                                                                <p>
                                                                                                  @if (learningCenter.afterDecide[11]?.value) {
                                                                                                    <b
                                                                                                      [innerHTML]="learningCenter.afterDecide[10]?.value"
                                                                                                      ></b
                                                                                                      >
                                                                                                      }<br />
                                                                                                      <span [innerHTML]="learningCenter.afterDecide[11]?.value"></span>
                                                                                                    </p>
                                                                                                  </div>
                                                                                                }
                                                                                                <!-- FMLA After Decision ends -->
                                                                                                <!-- TODO -->
                                                                                                @if (!isShown) {
                                                                                                  <h2 class="app-lc-header-2" id="lc-how" role="heading">
                                                                                                    {{ 'How Do All of These Claims Work?' | translation: translationRequest }}
                                                                                                  </h2>
                                                                                                }
                                                                                                @if (!isShown) {
                                                                                                  <div class="text">
                                                                                                    {{ 'Wondering what types of claims apply to what situations? Take a look at the table below for a quick overview.' | translation: translationRequest }}
                                                                                                  </div>
                                                                                                }
                                                                                                @if (!isShown) {
                                                                                                  <table class="tw-w-full" aria-label="Claims Information">
                                                                                                    <thead>
                                                                                                      <tr>
                                                                                                      <th style="width:20%" colspan="1" scope="col"></th>
                <th style="width:20%; line-height: 40px;" class="table-header" scope="col">
                                                                                                          {{ 'Short Term Disability' | translation: translationRequest }}
                                                                                                        </th>
                <th style="width:20%; line-height: 40px;" class="table-header" scope="col">
                                                                                                          {{ 'FMLA/State Leave' | translation: translationRequest }}
                                                                                                        </th>
                <th style="width:20%; line-height: 40px;" class="table-header" scope="col">
                                                                                                          {{ "Workers' Compensation" | translation: translationRequest }}
                                                                                                        </th>
                <th style="width:20%; line-height: 40px;" class="table-header" scope="col">ADA</th>
                                                                                                      </tr>
                                                                                                    </thead>
                                                                                                    <tbody>
                                                                                                      <tr>
                                                                                                        <th class="table-header-left" scope="row">
                                                                                                          {{ 'Unable to work due to an injury that occured outside of work' | translation: translationRequest }}
                                                                                                        </th>
                                                                                                        <td class="check-container">
                                                                                                          <mat-icon
                                                                                                            class="check"
                                                                                                            aria-label="Unable to work due to an injury that occured outside of work checked"
                                                                                                            tabindex="0"
                                                                                                            aria-hidden="false"
                                                                                                            >check</mat-icon
                                                                                                            >
                                                                                                          </td>
                                                                                                          <td class="check-container">
                                                                                                            <mat-icon
                                                                                                              class="check"
                                                                                                              aria-label="Unable to work due to an injury that occured outside of work checked"
                                                                                                              tabindex="0"
                                                                                                              scope="row"
                                                                                                              aria-hidden="false"
                                                                                                              >check</mat-icon
                                                                                                              >
                                                                                                            </td>
                                                                                                            <td></td>
                                                                                                            <td></td>
                                                                                                          </tr>
                                                                                                          <tr>
                                                                                                            <th class="table-header-left" scope="row">
                                                                                                              {{ 'Unable to work due to an injury that occured at work' | translation: translationRequest }}
                                                                                                            </th>
                                                                                                            <td></td>
                                                                                                            <td class="check-container">
                                                                                                              <mat-icon
                                                                                                                class="check"
                                                                                                                aria-label="Unable to work due to an injury that occured at work checked"
                                                                                                                tabindex="0"
                                                                                                                aria-hidden="false"
                                                                                                                >check</mat-icon
                                                                                                                >
                                                                                                              </td>
                                                                                                              <td class="check-container">
                                                                                                                <mat-icon
                                                                                                                  class="check"
                                                                                                                  aria-label="Unable to work due to an injury that occured at work checked"
                                                                                                                  tabindex="0"
                                                                                                                  aria-hidden="false"
                                                                                                                  >check</mat-icon
                                                                                                                  >
                                                                                                                </td>
                                                                                                                <td></td>
                                                                                                              </tr>
                                                                                                              <tr>
                                                                                                                <th class="table-header-left" scope="row">
                                                                                                                  {{ 'Unable to work 2 days every month due to my own chronic health condition' | translation: translationRequest }}
                                                                                                                </th>
                                                                                                                <td></td>
                                                                                                                <td class="check-container">
                                                                                                                  <mat-icon
                                                                                                                    class="check"
                    aria-label="Unable to work 2 days every month due to my own chronic health
            condition checked"
                                                                                                                    tabindex="0"
                                                                                                                    aria-hidden="false"
                                                                                                                    >check</mat-icon
                                                                                                                    >
                                                                                                                  </td>
                                                                                                                  <td></td>
                                                                                                                  <td></td>
                                                                                                                </tr>
                                                                                                                <tr>
                                                                                                                  <th scope="row" class="table-header-left">
                                                                                                                    {{ 'Unable to work for 3 weeks to care for an ill family member' | translation: translationRequest }}
                                                                                                                  </th>
                                                                                                                  <td></td>
                                                                                                                  <td class="check-container">
                                                                                                                    <mat-icon
                                                                                                                      class="check"
                                                                                                                      aria-label="Unable to work for 3 weeks to care for an ill family member checked"
                                                                                                                      tabindex="0"
                                                                                                                      aria-hidden="false"
                                                                                                                      >check</mat-icon
                                                                                                                      >
                                                                                                                    </td>
                                                                                                                    <td></td>
                                                                                                                    <td></td>
                                                                                                                  </tr>
                                                                                                                  <tr>
                                                                                                                    <th scope="row" class="table-header-left">
                                                                                                                      {{ 'Unable to be totally successful at work due to limited functionality' | translation: translationRequest }}
                                                                                                                    </th>
                                                                                                                    <td></td>
                                                                                                                    <td></td>
                                                                                                                    <td></td>
                                                                                                                    <td class="check-container">
                                                                                                                      <mat-icon
                                                                                                                        class="check"
                                                                                                                        aria-label="Unable to be totally successful at work due to limited functionality checked"
                                                                                                                        tabindex="0"
                                                                                                                        aria-hidden="false"
                                                                                                                        >check</mat-icon
                                                                                                                        >
                                                                                                                      </td>
                                                                                                                    </tr>
                                                                                                                  </tbody>
                                                                                                                </table>
                                                                                                              }
                                                                                                              <div id='endOfElement' tabindex="-1">&nbsp;</div>
                                                                                                            </div>
                                                                                                          }
    
                                                                                                          <!-- RHS MENU -->
                                                                                                          <div
                                                                                                            class="tw-hidden lg:tw-block tw-flex-none tw-max-w-[220px] app-lc-menu"
                                                                                                            >
                                                                                                            <app-sticky-menu
                                                                                                              #stickyMenu
                                                                                                              [currentSection]="currentSection"
                                                                                                              (sectionChange)="onSectionChange($event)"
                                                                                                              >
                                                                                                              <div class="app-pt2">
                                                                                                                <div class="app-lc-sticky-link"><b>FMLA</b></div>
                                                                                                                @if (isIntroduction) {
                                                                                                                  <div
                                                                                                                    class="app-lc-sticky-link"
                                                                                                                    [class.active-sidelink]="currentSection === 'lc-intro'"
                                                                                                                    >
                                                                                                                    <a tabindex="0" (click)="scrollToSection('lc-intro')"
                                                                                                                      >{{ 'Introduction' | translation: translationRequest }}</a
                                                                                                                      >
                                                                                                                    </div>
                                                                                                                  }
                                                                                                                  @if (isFMLADetails) {
                                                                                                                    <div
                                                                                                                      class="app-lc-sticky-link"
                                                                                                                      [class.active-sidelink]="currentSection === 'lc-Details'"
                                                                                                                      >
                                                                                                                      <a tabindex="0" (click)="scrollToSection('lc-Details')"
                                                                                                                        >{{ 'FMLA Details' | translation: translationRequest }}</a
                                                                                                                        >
                                                                                                                      </div>
                                                                                                                    }
    
                                                                                                                    <div
                                                                                                                      class="app-lc-sticky-link"
                                                                                                                      [class.active-sidelink]="currentSection === 'lc-sub'"
                                                                                                                      >
                                                                                                                      <a tabindex="0" (click)="scrollToSection('lc-sub')"
                                                                                                                        >{{ 'FMLA Submitting Claim Information' | translation: translationRequest }}</a
                                                                                                                        >
                                                                                                                      </div>
                                                                                                                      @if (isWhatsnext) {
                                                                                                                        <div
                                                                                                                          class="app-lc-sticky-link"
                                                                                                                          [class.active-sidelink]="currentSection === 'lc-next'"
                                                                                                                          >
                                                                                                                          <a tabindex="0" (click)="scrollToSection('lc-next')"
                                                                                                                            >{{ "FMLA What's Next" | translation: translationRequest }}</a
                                                                                                                            >
                                                                                                                          </div>
                                                                                                                        }
                                                                                                                        @if (isAfterdecision) {
                                                                                                                          <div
                                                                                                                            class="app-lc-sticky-link"
                                                                                                                            [class.active-sidelink]="currentSection === 'lc-after'"
                                                                                                                            >
                                                                                                                            <a tabindex="0" (click)="scrollToSection('lc-after')"
                                                                                                                              >{{ 'FMLA After your Decision is made' | translation: translationRequest }}</a
                                                                                                                              >
                                                                                                                            </div>
                                                                                                                          }
                                                                                                                          @if (!isShown) {
                                                                                                                            <div
                                                                                                                              class="app-lc-sticky-link"
                                                                                                                              [class.active-sidelink]="currentSection === 'lc-how'"
                                                                                                                              >
                                                                                                                              <a tabindex="0" (click)="scrollToSection('lc-how')"
                                                                                                                                >{{ 'How Do All of These Claims Work' | translation: translationRequest }}</a
                                                                                                                                >
                                                                                                                              </div>
                                                                                                                            }
                                                                                                                          </div>
                                                                                                                        </app-sticky-menu>
                                                                                                                      </div>
                                                                                                                    </div>
    `,
    styles: [
        `
      table td {
        border-color: silver;
        border-style: solid;
        border-width: 0 1px 1px 0;
      }

      .tblcolumn {
        width: 20%;
      }

      .app-lc-text {
      }

      .app-lc-menu {
        border-left: 1px solid var(--color-light-grey);
        padding-left: 16px;
        margin-left: 16px;
      }
      .table-container {
      }
      .table-container > div {
        border-color: silver;
        border-style: solid;
        border-width: 0 1px 1px 0;
      }
      .check-container {
        text-align: center;
        vertical-align: middle;
        line-height: 48px;
      }
      .check {
        font-size: 48px;
        width: 48px;
        height: 48px;
        color: var(--sed-purple-80-color) !important;
      }
      .app-lc-header {
        color: var(--sed-dynamic-black-color);
        font-size: 32px;
        padding: 32px 0 16px 0;
        font-weight: bold;
        line-height: 34px;
      }
      .app-lc-text {
      }

      .app-lc-menu {
        border-left: 1px solid var(--color-light-grey);
        padding-left: 16px;
        margin-left: 16px;
      }
      .left-wrap {
        float: left;
      }
      .right-wrap {
        float: right;
      }
      .center {
        text-align: center;
      }
      .mat-icon {
        margin: auto;
      }
      p + p {
        margin-top: 10px;
      }
      .app-p {
        margin-top: 10px;
        margin-bottom: 10px;
      }
    `,
    ],
    standalone: false
})
export class LearningCenterLvComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input()
  isMgr: boolean;

  @Input()
  learningCenter: any;

  @Input()
  loading: boolean;
  isShown: boolean = false;

  scrollToElement = scrollToElement;
  @Input()
  lcType: string;

  @Input()
  translationRequest: TranslationRequest;

  isReportClaimLinkBound: boolean = false;
  isOpenfile: boolean = false;
  documentUrl: string;
  isLearnMoreLinkBound: boolean = false;
  isLearnMore: boolean = false;
  mappings: any = [];

  isIntroduction: boolean = false;
  isWhatisLV: boolean = false;
  isFMLADetails: boolean = false;
  isSubmittingClaim: boolean = false;
  isWhatsnext: boolean = false;
  isAfterdecision: boolean = false;
  currentSection: string = 'lc-intro';

  @ViewChild('dynamicContentContainer') container: ElementRef;
  @ViewChild('stickyMenu') stickyMenu!: StickyMenuComponent;
  private unlistens: (() => void)[] = [];
  constructor(
    private session: Session,
    public learningCenterService: LearningCenterService,
    private dialog: MatDialog,
    public openFileService: OpenFileService,
    private router: Router,
    private bindEvents: DynamicEventBindService,
    private renderer: Renderer2,
    public claimConfigService: ConfigurationService,
    private display: DisplayService
  ) {}

  subs = new SubSink();

  ngAfterViewInit(): void {
    if (this.mappings?.length) {
      this.unlistens = this.bindEvents.bindDynamicEvents(
        this.container,
        this.mappings
      );
    }
  }

  async ngOnInit() {
    const params = getUrlParams();
    //console.log(this.learningCenter);

    this.buildDocumentLink();
    this.checkHeaderValues();
    this.mappings = [
      {
        selector: '.report-new-claim',
        action: this.reportClaim.bind(this),
      },
      {
        selector: '.medical-provider',
        action: this.openFileLink.bind(this),
      },
      {
        selector: '.learn-more',
        action: this.openLearnMore.bind(this),
      },
      {
        selector: '.go-to-personal-notif',
        route: '/PreferencesPage',
        queryParams: {
          source: this.learningCenter.claimInfo.source,
          claimId: this.learningCenter.claimInfo.claimId,
        },
      },
      {
        selector: '.go-to-comm-center',
        route: '/claims',
        queryParams: {
          source: this.learningCenter.claimInfo.source,
          claimId: this.learningCenter.claimInfo.claimId,
          focus: 'comm-center',
        },
      },
      {
        selector: '.go-to-pharmacy-card',
        route: '/pharmacy-card',
        queryParams: {
          source: this.learningCenter.claimInfo.source,
          claimId: this.learningCenter.claimInfo.claimId,
        },
      },
      {
        selector: '.go-to-documents',
        route: '/claims',
        queryParams: {
          source: this.learningCenter.claimInfo.source,
          claimId: this.learningCenter.claimInfo.claimId,
          focus: 'DOCUMENTS',
        },
      },
      {
        selector: '.go-to-documents-upload',
        route: '/upload-documents-in-documentstab',
        queryParams: {
          source: this.learningCenter.claimInfo.source,
          claimId: this.learningCenter.claimInfo.claimId,
          focus: 'documents',
          showDialog: true,
        },
      },
      {
        selector: '.go-to-documents-show',
        route: '/upload-documents-in-documentstab',
        queryParams: {
          source: this.learningCenter.claimInfo.source,
          claimId: this.learningCenter.claimInfo.claimId,
          focus: 'documents',
          showDialog: false,
        },
      },
    ];
    this.checkViaClaim();
    await this.claimConfigService.initializeConfig();
  }

  buildDocumentLink() {
    if (!this.isMgr)
      this.documentUrl = `/claims?source=${this.learningCenter.claimInfo.source}&claimId=${this.learningCenter.claimInfo.claimId}&focus=DOCUMENTS`;
  }

  openFileLink(event: MouseEvent) {
    event.stopPropagation();
    this.openFileService.openfile();
  }

  reportClaim(event: MouseEvent) {
    event.preventDefault();
    reportNewClaim(this.dialog);
  }

  openLearnMore(event: MouseEvent) {
    event.preventDefault();
    const element = event.target as HTMLElement;
    let url = element.getAttribute('href');
    const dialogRef = this.dialog.open(ExternalLinkDialogComponent);
    this.subs.sink = dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        window.open(url, '_blank');
      }
    });
  }

  checkViaClaim() {
    if (this.learningCenter.claimInfo.claimId != null) {
      this.isShown = !this.isShown;
    }
  }

  redirectToDocUpload() {
    this.router.navigate(['../upload-documents-in-documentstab'], {
      queryParams: {
        source: this.learningCenter.claimInfo.source,
        claimId: this.learningCenter.claimInfo.claimId,
        focus: 'documents',
        showDialog: true,
      },
    });
  }

  ngOnDestroy(): void {
    this.unlistens.forEach((unlisten) => unlisten());
    this.subs.unsubscribe();
  }

  checkHeaderValues() {
    if (this.checkArrayValue(this.learningCenter.introductionResults, 0)) {
      this.isIntroduction = true;
    }
    if (this.checkArrayValue(this.learningCenter.introductionResults, 2)) {
      this.isWhatisLV = true;
    }
    if (this.checkArrayValue(this.learningCenter.fmlaDetails, 0)) {
      this.isFMLADetails = true;
    }
    if (this.checkArrayValue(this.learningCenter.whatsnexts, 0)) {
      this.isWhatsnext = true;
    }

    if (this.checkArrayValue(this.learningCenter.afterDecide, 0)) {
      this.isAfterdecision = true;
    }
  }
  checkArrayValue(arr: any[], index: number) {
    const arrVal = arr.slice();
    if (index > 0) {
      arrVal.splice(index - 1, 1);
      return arrVal.some((obj) => obj.value !== '');
    } else {
      return arrVal.some((obj) => obj.value !== '');
    }
  }

  onSectionChange(section: string) {
    this.currentSection = section;
  }

  scrollToSection(sectionId: string) {
    this.stickyMenu.scrollToSection(sectionId);
  }
}
